import { Box, Skeleton, Typography } from "@material-ui/core";
import React from "react";
import { useTranslation } from "react-i18next";
import { getCookie } from "../../utils/cookies";
import {mainPageIDs} from "../../qaIDs.json"

const isToday = (date: Date): boolean => {
  const today = new Date();
  return (
    date.getDate() == today.getDate() &&
    date.getMonth() == today.getMonth() &&
    date.getFullYear() == today.getFullYear()
  );
};

const addZero = (num: number): string => (num < 10 ? "0" + num : String(num));

// Get hours and minutes
export const getHoursMins = (num: number): string | null => {
  if (!num) return null;
  const hours = new Date(num).getUTCHours();
  const minutes = new Date(num).getUTCMinutes();
  return !isNaN(hours) && !isNaN(minutes)
    ? `${addZero(hours)}:${addZero(minutes)}`
    : "";
};

const getLang = () => {
  const language = getCookie("lng");

  switch(language) {
    case "nl":
      return "nl-NL";
    case "de":
      return "de-DE";
    default:
      return "en-US";
  }

}

export default function TrackingDetailsHeader({
  data,
  dataLoaded
}: {
  data: any;
  dataLoaded: boolean;
}) {
  const {
    time_window,
    project_date,
    route_status,
    stop_status,
    stop_type,
    eta,
    driver_location,
    finished_time
  } = data;

  const { t } = useTranslation();

  const topStatus =
    stop_status === "finished"
      ? stop_type === "pickup"
        ? t("Picked up")
        : t("Delivered")
      : stop_status === "skipped"
      ? stop_type === "pickup"
        ? t("Pickup failed")
        : t("Delivery failed")
      : t("Arrival time");


  const etaWindowStart = getHoursMins(eta * 1000 - 15 * 60 * 1000);
  const etaWindowEnd = getHoursMins(eta * 1000 + 15 * 60 * 1000);

  const today: boolean = isToday(new Date(project_date));

  const unknownStatus: boolean =
    route_status === "finished" &&
    !["finished", "skipped"].includes(stop_status);

  const shouldShowExpected = !eta; 

  return (
    <Box p={3}>
      {dataLoaded ? (
        <>
          <Typography variant="h5" id={mainPageIDs.arrivalTimeText}>{topStatus}</Typography>
          {shouldShowExpected && (
            <Typography color="textSecondary" sx={{ marginTop: "8px" }}>
      
            </Typography>
          )}
          <Typography color="textSecondary" sx={{ marginTop: "8px" }}>
            {shouldShowExpected && `${t("Expected")} `}
            {today
              ? t("Today")
              : new Date(project_date).toLocaleDateString(
                  getLang(),
                  {
                    weekday: "long",
                    month: "short",
                    day: "numeric"
                  }
                )}{" "}
            {!unknownStatus &&
              (driver_location || ["finished", "skipped"].includes(stop_status)
                ? t("at")
                : (eta || time_window) && `${t("between")} `)}
            <Typography
              id={mainPageIDs.trackingDetailsTW}
              component="b"
              color="textPrimary"
              sx={{ fontWeight: 500 }}
            >
              {!unknownStatus &&
                (["finished", "skipped"].includes(stop_status)
                  ? getHoursMins(finished_time * 1000)
                  : driver_location
                  ? getHoursMins(eta * 1000)
                  : route_status === "in_progress"
                  ? `${etaWindowStart}-${etaWindowEnd}`
                  : time_window)}
            </Typography>
          </Typography>
        </>
      ) : (
        <Box height={64}>
          <Skeleton />
        </Box>
      )}
    </Box>
  );
}
